import {Component, Input} from '@angular/core';
import {DashboardBoxesHeadData} from "../../interfaces/dashboard-boxes-head-data";

@Component({
  selector: 'brt-dashboard-boxes-head',
  templateUrl: './dashboard-boxes-head.component.html',
  styleUrls: ['./dashboard-boxes-head.component.scss']
})
export class DashboardBoxesHeadComponent {
  @Input('data') set setData(data: Partial<DashboardBoxesHeadData>) {
    this.data = {
      ...this.data,
      ...data
    }

    if(this.data.sortCallback) {
      this.hasSort = true;
    }
  }

  hasSort = false;

  data: DashboardBoxesHeadData = {
    size: "large",
    title: "",
    titleIcon: "",
    titleAmount: undefined,
    hint: "",
    hintIcon: "",
    color: "white",
    addHintPulseCircle: false,
    menuItemActions: [],
    tooltip: "",
    hintSort: "NONE"
  }

  onHintClick() {
    if(this.hasSort) {
      const newSort = this.data.hintSort === "ASC" ? "DESC" : "ASC";
      this.data = {
        ...this.data,
        hintSort: newSort
      }

      if(this.data.sortCallback) {
        this.data.sortCallback(newSort);
      }
    }
  }
}
